export default function initCouponCopy() {
  document.querySelectorAll('.code-pill').forEach(el => {
    el.addEventListener('click', async () => {
      const txt = el.dataset.code || el.textContent.trim();
      try { await navigator.clipboard.writeText(txt); } catch (_) { }
      const old = el.textContent;
      el.textContent = 'Copied!';
      el.style.background = '#dff7ea';
      el.style.color = '#0d7a47';
      el.style.borderColor = '#9fd9b8';
      setTimeout(() => {
        el.textContent = old;
        el.style.background = '';
        el.style.color = '';
        el.style.borderColor = '';
      }, 1100);
    });
  });
}
